import { defineComponent as _defineComponent } from 'vue'
import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import PulseMonitoring from './PulseMonitoring.vue';

  import { ref } from 'vue';
  import PulseSettings from './PulseSettings.vue';

  
  const __default__ = {
    name: 'Pulse',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const tabs = ref<Array<String>>(['Monitoring', 'Settings']);
  const activeTab = ref<String | null>(tabs.value[0]);

  function setActiveTab(tab: String) {
    activeTab.value = tab;
  }

return { __sfc: true,tabs, activeTab, setActiveTab, BaseText, PulseMonitoring, PulseSettings }
}

})